import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFoundFallback from "@Components/Pages/Fallbacks/NotFound";
import Logout from "@Components/Pages/Logout";
import { AWARDED_CONTRACTS, CUSTOMERS, DEVICES, INSTANT_DEALS_WON, LOGOUT, MY_ACCOUNT, NOT_FOUND, PARTNERS, ROAMING_DAYS, ROOT, SUPPLIERS, TARIFF_PLAN_TYPES, USERS, } from "@Shared/Paths/Admin";
import MyAccount from "@SmartComponents/User/MyAccount";
import AdminUsers from "./AdminUsers";
import AwardedContracts from "./AwardedContracts";
import RoamingDays from "./CountrySettings/RoamingDays";
import TariffPlanTypes from "./CountrySettings/TariffPlanTypes";
import Customers from "./Customers";
import Dashboard from "./Dashboard";
import Devices from "./Devices";
import InstantDealsWon from "./InstantDealsWon";
import Partners from "./Partners";
import Suppliers from "./Suppliers";
export default () => {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: ROOT, exact: true },
            React.createElement(Dashboard, null)),
        React.createElement(Route, { path: USERS },
            React.createElement(AdminUsers, null)),
        React.createElement(Route, { path: CUSTOMERS },
            React.createElement(Customers, null)),
        React.createElement(Route, { path: PARTNERS },
            React.createElement(Partners, null)),
        React.createElement(Route, { path: SUPPLIERS },
            React.createElement(Suppliers, null)),
        React.createElement(Route, { path: DEVICES },
            React.createElement(Devices, null)),
        React.createElement(Route, { path: AWARDED_CONTRACTS },
            React.createElement(AwardedContracts, null)),
        React.createElement(Route, { path: INSTANT_DEALS_WON },
            React.createElement(InstantDealsWon, null)),
        React.createElement(Route, { path: MY_ACCOUNT },
            React.createElement(MyAccount, null)),
        React.createElement(Route, { path: ROAMING_DAYS },
            React.createElement(RoamingDays, null)),
        React.createElement(Route, { path: TARIFF_PLAN_TYPES },
            React.createElement(TariffPlanTypes, null)),
        React.createElement(Route, { path: LOGOUT },
            React.createElement(Logout, null)),
        React.createElement(Route, { path: NOT_FOUND },
            React.createElement(NotFoundFallback, null))));
};
